import { render, staticRenderFns } from "./PatientEstimateAscFeeModal.vue?vue&type=template&id=ff1a4032&scoped=true"
import script from "./PatientEstimateAscFeeModal.vue?vue&type=script&lang=js"
export * from "./PatientEstimateAscFeeModal.vue?vue&type=script&lang=js"
import style0 from "./PatientEstimateAscFeeModal.vue?vue&type=style&index=0&id=ff1a4032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1a4032",
  null
  
)

export default component.exports